// scheduling/components/SettingsModal.jsx
// RPRS Settings modal — opened from the ⚙️ gear in the top-right header. A simple
// vertical list of setting sections; V1 has one (Outlook Calendar Sync). Add future
// sections (Zoom notifications, etc.) as siblings inside .app-settings-body.
// Modal skeleton mirrors IDDHelpModal (overlay closes, panel stops propagation).

import OutlookSyncSetting from './OutlookSyncSetting';

export default function SettingsModal({ open, onClose, staffId, optIn, onOptInChange, highlightOutlook }) {
  if (!open) return null;
  return (
    <div className="app-modal-overlay" onClick={onClose}>
      <div className="app-modal app-settings-modal" onClick={(e) => e.stopPropagation()}>
        <button className="app-modal-close" onClick={onClose} aria-label="Close settings">×</button>
        <h2 className="app-modal-title">Settings</h2>
        <div className="app-settings-body">
          <OutlookSyncSetting
            staffId={staffId}
            optIn={optIn}
            onOptInChange={onOptInChange}
            highlight={highlightOutlook}
          />
          {/* Future setting sections go here. */}
        </div>
      </div>
    </div>
  );
}
